var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"player"}},[_c('sk-player',{attrs:{"shows-api":_vm.shows,"stream-api":_vm.api,"stream-url":_vm.feed,"country":_vm.country}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }